'use client';
import React from 'react';
import FeaturedJob from '~/components/jobs/featured-job';
import { JobDetail } from '~/types/job-detail';
import ErrorBoundary from '~/components/error-boundary';

type Props = {
  jobs: JobDetail[];
  title?: string;
  isMobile: boolean;
  isSignedIn: boolean;
  favoriteJobIds: number[];
};

const JobSimilarity: React.FC<Props> = ({
  jobs,
  title = '関連度の高い求人',
  isMobile,
  isSignedIn,
  favoriteJobIds,
}) => {
  if (!jobs || jobs.length === 0) return null;

  return (
    <div className="c-panel --no-print -job-detail">
      {!isMobile && (
        <div className="u-pl20 u-pr20">
          <h2 className="c-panel__header">{title}</h2>
          <div className="p-featured-jobs -col4">
            {jobs.map((job) => (
              <ErrorBoundary key={job.id}>
                <FeaturedJob
                  key={job.id}
                  job={job}
                  isMobile={isMobile}
                  isSignedIn={isSignedIn}
                  favoriteJobIds={favoriteJobIds}
                />
              </ErrorBoundary>
            ))}
          </div>
        </div>
      )}

      {isMobile && (
        <>
          <h2 className="c-panel__header -no-border u-fs-sp16 u-pl16">
            {title}
          </h2>
          <div className="c-panel__body">
            <div className="p-featured-jobs">
              <div className="u-flex u-gap15">
                {jobs.map((job) => (
                  <ErrorBoundary key={job.id}>
                    <FeaturedJob
                      key={job.id}
                      job={job}
                      gtmClass="gtm-sp-job_featured-job_similarity"
                      isMobile={isMobile}
                      isSignedIn={isSignedIn}
                      favoriteJobIds={favoriteJobIds}
                    />
                  </ErrorBoundary>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default JobSimilarity;
